import $ from 'jquery';
const POST_URL = '/register-newsletter/';

function NewsletterForm(root) {
    this._root = root;
    this.loading = false;
}
NewsletterForm.prototype = {
    init: function() {
        this._root.on('submit', (ev) => {
            ev.preventDefault();
            if (this.loading) {
                return;
            }
            this.setLoading(true);
            this.send();
        });
    },
    setLoading: function(loading) {
        this.loading = loading;
        if (loading) {
            this._root.addClass('loading');
        } else {
            this._root.removeClass('loading');
        }
    },
    getCSRF: function() {
        return this._root.find('input[name=csrfmiddlewaretoken]').val();
    },
    getData: function() {
        return {
            csrfmiddlewaretoken: this.getCSRF(),
            email: this._root.find('[name=email]').val(),
            surname: this._root.find('[name=surname]').val(),
            name: this._root.find('[name=name]').val(),
            postalcode: this._root.find('[name=postalcode]').val().toString(),
        };
    },
    send: function() {
        return $.ajax({
            type: 'POST',
            url: POST_URL,
            data: this.getData(),
        })
        .then((response) => {
            this._root.append('<div class="success">Merci pour votre inscription !</div>');
            this._root[0].reset(false);
            this._root.find('.not-empty').removeClass('not-empty');
        }, (response) => {
            this._root.append('<div class="error">Il y a eu une erreur, ' +
                              'merci de soumettre le formulaire de nouveau</div>');
        })
        .then(() => {
            this.setLoading(false);
        });
    },
};
export default NewsletterForm;



// WEBPACK FOOTER //
// ./scripts/register-newsletter.js